import React from 'react';
import _ from 'lodash';
import { Card, Divider } from 'antd';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { buildDimensionOptions } from './../../utils/survey';
import { VictoryChart, VictoryAxis, VictoryTheme, VictoryBar } from 'victory';
import ResultTotalAnswers from '../ResultTotalAnswers';
import ResultTitle from '../ResultTitle';

const DimensionStep = ({ id, stepAnswers, questions, intl: { formatMessage } }) => {
	const answerValues = Object.values(stepAnswers);
	const options = buildDimensionOptions(answerValues);
	return (
		<Card className='Result'>
			<div className='Answer'>
				<ResultTitle questions={questions} id={id}/>
				<ResultTotalAnswers stepAnswers={stepAnswers}/>
			</div>
			<Divider/>
			<div className='Answer' style={{ display: 'flex', flexWrap: 'wrap', width: '100%', maxWidth: 500, margin: '0 auto' }}>
				<div className="chart" style={{ position: 'relative', margin:'0 auto', width: '400px' }}>
					<div className="labelY">{formatMessage(messages.labelYDim1)}</div>
					<VictoryChart theme={VictoryTheme.material}>
						<VictoryBar style={{ data: { fill: '#1E90FF' } }} horizontal
						            data={_.toPairs(options[0]).map(a => ({ x: a[0], y: a[1] }))}/>
						<VictoryAxis
							label={formatMessage(messages.labelXDim1)}
							tickFormat={(t) => ~~t !== t ? null : t}
							style={{
								axisLabel: { fontSize: 12, padding: 25 },
								grid: { stroke: 'none' },
								ticks: { stroke: 'grey', size: 5 },
								tickLabels: { fontSize: 10, padding: 5 }
							}}
						/>
						<VictoryAxis
							dependentAxis
							tickFormat={(t) => `${Math.round(t)}cm`}
							style={{
								axisLabel: { fontSize: 12, padding: 35 },
								grid: { stroke: 'none' },
								ticks: { stroke: 'grey', size: 5 },
								tickLabels: { fontSize: 10, padding: 2 }
							}}
						/>
					</VictoryChart>
				</div>
				
				<div style={{ position: 'relative', margin:'0 auto', width: '400px' }}>
					<div className="labelY">{formatMessage(messages.labelYDim2)}</div>
					<VictoryChart theme={VictoryTheme.material}>
						<VictoryBar style={{ data: { fill: '#1E90FF' } }} horizontal
						            data={_.toPairs(options[1]).map(a => ({ x: a[0], y: a[1] }))}/>
						<VictoryAxis
							label={formatMessage(messages.labelXDim2)}
							tickFormat={(t) => ~~t !== t ? null : t}
							style={{
								axisLabel: { fontSize: 12, padding: 25 },
								grid: { stroke: 'none' },
								ticks: { stroke: 'grey', size: 5 },
								tickLabels: { fontSize: 10, padding: 5 }
							}}
						/>
						<VictoryAxis
							dependentAxis
							tickFormat={(t) => `${Math.round(t)}cm`}
							style={{
								axisLabel: { fontSize: 12, padding: 35 },
								grid: { stroke: 'none' },
								ticks: { stroke: 'grey', size: 5 },
								tickLabels: { fontSize: 10, padding: 2 }
							}}
						/>
					</VictoryChart>
				</div>
				
				<div style={{ position: 'relative', margin:'0 auto', width: '400px' }}>
					<div className="labelY">{formatMessage(messages.labelYDim3)}</div>
					<VictoryChart theme={VictoryTheme.material}>
						<VictoryBar style={{ data: { fill: '#1E90FF' } }} horizontal
						            data={_.toPairs(options[2]).map(a => ({ x: a[0], y: a[1] }))}/>
						<VictoryAxis
							label={formatMessage(messages.labelXDim3)}
							tickFormat={(t) => ~~t !== t ? null : t}
							style={{
								axisLabel: { fontSize: 12, padding: 25 },
								grid: { stroke: 'none' },
								ticks: { stroke: 'grey', size: 5 },
								tickLabels: { fontSize: 10, padding: 5 }
							}}
						/>
						<VictoryAxis
							dependentAxis
							tickFormat={(t) => `${Math.round(t)}cm`}
							style={{
								axisLabel: { fontSize: 12, padding: 35 },
								grid: { stroke: 'none' },
								ticks: { stroke: 'grey', size: 5 },
								tickLabels: { fontSize: 10, padding: 2 }
							}}
						/>
					</VictoryChart>
				</div>
			
			</div>
		</Card>
	);
};

export default injectIntl(DimensionStep);


// WEBPACK FOOTER //
// ./src/components/ResultDimensions/ResultDimensions.js